import { DisplayValues } from "@/components";
import { autoCompleteValueType } from "@/propTypes";
import { useGetDynamicAutoCompleteQuery } from "@/services";
import { string } from "prop-types";
import { useEffect, useState } from "react";
import {
  buildParameterizedUrl,
  getDisplayValue,
  hasValueForQueryParameter,
} from "./helper";

export const DefaultAutoCompleteDisplay = ({ url, value }) => {
  const [parameterizedUrl, setParameterizedUrl] = useState();
  const [displayValues, setDisplayValues] = useState([]);

  const { data: dynamicAutoCompleteValues, isFetching } =
    useGetDynamicAutoCompleteQuery(parameterizedUrl, {
      skip: !parameterizedUrl,
    });

  useEffect(() => {
    if (!dynamicAutoCompleteValues?.length) return;

    setDisplayValues(
      dynamicAutoCompleteValues.map(({ Document }) => getDisplayValue(Document))
    );
  }, [dynamicAutoCompleteValues]);

  useEffect(() => {
    if (!url || !hasValueForQueryParameter(value)) return;

    setParameterizedUrl(buildParameterizedUrl(url, value));
  }, [url, value]);

  return <DisplayValues values={displayValues} loading={isFetching} />;
};

DefaultAutoCompleteDisplay.propTypes = {
  url: string.isRequired,
  value: autoCompleteValueType.isRequired,
};
